import { render, staticRenderFns } from "./error.vue?vue&type=template&id=28f6ec55&lang=pug&"
import script from "./error.vue?vue&type=script&lang=js&"
export * from "./error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import KButton from '@/components/shared/Button/KButton.vue'
import KCard from '@/components/shared/Card/KCard.vue'
import KCardText from '@/components/shared/Card/KCardText.vue'
import KContainer from '@/components/shared/Container/KContainer.vue'
import { VApp } from 'vuetify/lib/components/VApp';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {KButton,KCard,KCardText,KContainer,VApp,VCardTitle,VCol,VImg,VRow})
